// export const IS_REQUESTING = "search/IS_REQUESTING";
// export const REQUESTING_END = "search/REQUESTING_END";

export const REQUEST_INFORMATION = "inquires/REQUEST_INFORMATION";
export const REQUEST_PLATE = "inquires/REQUEST_PLATE";
export const USER_INFORMATION = "inquires/USER_INFORMATION";
export const RESET_INQUIRES = "inquires/RESET_INQUIRES";
export const RESET_USER = "inquires/RESET_USER";
export const PLACES_ADRESS = "inquires/PLACES_ADRESS";

export const STEP_DIRECT = "step/STEP_DIRECT";
export const STEP_DECREMENT = "step/STEP_DECREMENT";
export const STEP_INCREMENT = "step/STEP_INCREMENT";
export const MOBILE = 'step/MOBILE';
export const ERROR_STATE = 'step/ERROR_STATE';
export const EXP_CHANGE = 'step/EXP_CHANGE';

export const SCROLL_VALUE = "scroll/SCROLL_VALUE";

export const EXTERNCALL_REST = "appointement/EXTERNCALL_REST";
export const DEALERS_BY_CAR = "appointement/DEALERS_BY_CAR";
export const CLEAR_HOUR = "appointement/CLEAR_HOUR";
export const UPDATE_USER = "appointement/UPDATE_USER";
export const DEALERS_INFO = "appointement/DEALERS_INFO";
export const IS_REQUESTING = "appointement/IS_REQUESTING";
export const REQUESTING_END = "appointement/REQUESTING_END";
export const CAR_INFO = "appointement/CAR_INFO";
export const TIME_INFO = "appointement/TIME_INFO";
export const APPOINTMENT = "appointement/APPOINTMENT";


export const LEAD_ID = "lead/LEAD_ID";
export const LEAD_IS_REQUESTING = "lead/LEAD_IS_REQUESTING";
export const LEAD_REQUESTING_END = "lead/LEAD_REQUESTING_END";






// WEBPACK FOOTER //
// ./src/actions/types.js